import React from "react";
import { redirect, useRouteLoaderData } from "react-router-dom";
import { userList } from "../../../api/user";
import TabLayout from "../../helpers/TabLayout";
import UsersTable from "./UsersTable";
import { testSessionLoader } from "../../../loaders/helpers";

const usersTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  let page = Number(url.searchParams.get("page"));
  page = isNaN(page) ? 0 : page;
  const userListRes = await userList(page);
  const users = userListRes.data;
  if (!users.length && page !== 0) throw redirect("?page=0");
  return { userList: users, page };
};

const UsersTab = () => {
  const { userList } = useRouteLoaderData("adminUserTab");
  let { page } = useRouteLoaderData("adminUserTab");

  const onPageButtonClicked = (newPage) => page = newPage;

  return (
    <>
      <TabLayout
        headerLabel="Users"
        skeletonLines={16}
      >
        <UsersTable
          usersList={userList}
          currentPage={page}
          onPageButtonClicked={onPageButtonClicked}
        />
      </TabLayout>
    </>
  );
};

export { usersTabLoader };
export default UsersTab;